<template>
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>

    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="page-header">
          <div class="content-page-header">
            <h5>Customers</h5>
            <div class="list-btn">
              <ul class="filter-list">
                <li>
                  <a class="btn-filters w-auto popup-toggle"
                    ><span><i class="feather feather-filter"></i></span>
                  </a>
                </li>
                <li>
                  <router-link class="btn btn-primary" to="/add-customer"
                    ><i class="fa fa-plus-circle me-2" aria-hidden="true"></i
                    >Add Customer</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /Page Header -->

        <!-- Add Asset -->
        <div class="toggle-sidebar">
          <div class="sidebar-layout-filter">
            <div class="sidebar-header">
              <h5>Filter</h5>
              <a href="javascript:;" class="sidebar-closes"
                ><i class="fa-regular fa-circle-xmark"></i
              ></a>
            </div>
            <div class="sidebar-body">
              <b-form action="#" autocomplete="off">
                <!-- Customer -->
                <div class="accordion" id="accordionMain1">
                  <a
                    href="javascript:void(0);"
                    class="w-100"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <div class="card-header-new" id="headingOne">
                      <h6 class="filter-title">
                        Customer
                        <span class="float-end"
                          ><i class="fa-solid fa-chevron-down"></i
                        ></span>
                      </h6>
                    </div>
                  </a>

                  <div
                    id="collapseOne"
                    class="collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample1"
                  >
                    <div class="card-body-chat">
                      <div class="row">
                        <div class="col-md-12">
                          <div id="checkBoxes1">
                            <div class="form-custom">
                              <input
                                type="text"
                                class="form-control"
                                v-model="searchForm.search"
                                id="member_search1"
                                placeholder="Search here"
                              />
                              <span
                                ><img
                                  src="@/assets/img/icons/search.svg"
                                  alt="img"
                              /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Customer -->

                <!-- Select Date -->
                <div class="accordion" id="accordionMain2">
                  <a
                    href="javascript:void(0);"
                    class="w-100 collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="true"
                    aria-controls="collapseTwo"
                  >
                    <div class="card-header-new" id="headingTwo">
                      <h6 class="filter-title">
                        Select Date
                        <span class="float-end"
                          ><i class="fa-solid fa-chevron-down"></i
                        ></span>
                      </h6>
                    </div>
                  </a>

                  <div
                    id="collapseTwo"
                    class="collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample2"
                  >
                    <div class="card-body-chat">
                      <div class="form-group">
                        <label class="form-control-label">From</label>
                        <div class="cal-icon">
                          <datepicker
                            v-model="startdate"
                            class="picker"
                            :editable="true"
                            :clearable="false"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="form-control-label">To</label>
                        <div class="cal-icon">
                          <datepicker
                            v-model="startdate"
                            class="picker"
                            :editable="true"
                            :clearable="false"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Select Date -->

                <!-- Category -->
                <div class="accordion accordion-last" id="accordionMain4">
                  <a
                    href="javascript:void(0);"
                    class="w-100 collapsed"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="true"
                    aria-controls="collapseFour"
                  >
                    <div class="card-header-new" id="headingFour">
                      <h6 class="filter-title">
                        Category
                        <span class="float-end"
                          ><i class="fa-solid fa-chevron-down"></i
                        ></span>
                      </h6>
                    </div>
                  </a>

                  <div
                    id="collapseFour"
                    class="collapse"
                    aria-labelledby="headingFour"
                    data-bs-parent="#accordionExample4"
                  >
                    <div class="card-body-chat">
                      <div id="checkBoxes3">
                        <div class="selectBox-cont">
                          <label class="custom_check w-100">
                            <input type="checkbox" name="category" />
                            <span class="checkmark"></span> Advertising
                          </label>
                          <label class="custom_check w-100">
                            <input type="checkbox" name="category" />
                            <span class="checkmark"></span> Food
                          </label>
                          <label class="custom_check w-100">
                            <input type="checkbox" name="category" />
                            <span class="checkmark"></span> Repairs
                          </label>
                          <label class="custom_check w-100">
                            <input type="checkbox" name="category" />
                            <span class="checkmark"></span> Software
                          </label>
                          <!-- View All -->
                          <div class="view-content">
                            <div class="viewall-Two">
                              <label class="custom_check w-100">
                                <input type="checkbox" name="username" />
                                <span class="checkmark"></span> Stationary
                              </label>
                              <label class="custom_check w-100">
                                <input type="checkbox" name="username" />
                                <span class="checkmark"></span> Medical
                              </label>
                              <label class="custom_check w-100">
                                <input type="checkbox" name="username" />
                                <span class="checkmark"></span> Designing
                              </label>
                            </div>
                            <div class="view-all">
                              <a
                                href="javascript:void(0);"
                                class="viewall-button-Two"
                                ><span class="me-2">View All</span
                                ><span
                                  ><i
                                    class="fa fa-circle-chevron-down"
                                  ></i></span
                              ></a>
                            </div>
                          </div>
                          <!-- /View All -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /Category -->

                <button
                  @click="resetSearchForm"
                  class="d-inline-flex align-items-center justify-content-center btn w-100 btn-primary"
                >
                  <span><i class="feather feather-refresh-ccw me-2"></i></span
                  >Reset
                </button>
              </b-form>
            </div>
          </div>
        </div>
        <!--/Add Asset -->

        <div class="row">
          			        <div class="col-md-3 mb-3">
                
          <div class="form-custom">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Search anything..."
             		v-model="searchForm.search"
            />
        
          </div>
        </div>
				
          <div class="col-sm-12">
            <div class="card-table">
              <div class="card-body">
                <div class="table-responsive">
                  <a-table
                    class="stripped table-hover"
                    :columns="columns"
                    :loading="isFetching"
                    :data-source="customers.data"
                    :pagination="false"
                  >
                    <template #bodyCell="{ column, record, index }">
                      <template v-if="column.key === 'index'">
                        <span>{{ index + 1 }}</span>
                      </template>
                      <template v-else-if="column.key === 'name'">
                        <router-link
                          style="color: #878a99"
                          :to="`/customer-details/` + record.id"
                        >
                          {{ record.name }}</router-link
                        >
                      </template>
                      <template v-else-if="column.key === 'email'">
                        {{ record.email }}
                      </template>
                      <template v-else-if="column.key === 'phone'">
                        {{ `${record.country_code} ${record.phone}` }}
                      </template>
                      <template v-else-if="column.key === 'amount_due'">
                        <span>{{ useCurrency(record.amount_due) }}</span>
                      </template>
                      <template v-else-if="column.key === 'created_at'">
                        <span>{{ formatted(record.created_at) }}</span>
                      </template>
                      <template v-if="column.key === 'action'">
                        <div
                          class="d-flex align-items-center justify-content-start"
                        >
                          <div class="dropdown dropdown-action">
                            <a
                              href="javascript:;"
                              class="btn-action-icon"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              >Action</a
                            >
                            <div class="dropdown-menu dropdown-menu-end">
                              <ul>
                                <li>
                                  <router-link
                                    class="dropdown-item"
                                    :to="`/customer-details/` + record.id"
                                    ><i class="far fa-eye me-2"></i
                                    >View</router-link
                                  >
                                </li>
                                <li>
                                  <router-link
                                    class="dropdown-item"
                                    :to="`/edit-customer/` + record.id"
                                    ><i class="far fa-edit me-2"></i
                                    >Edit</router-link
                                  >
                                </li>
                                <li>
                                  <a
                                    class="dropdown-item"
                                    href="javascript:void(0);"
                                    @click="openModal(record)"
                                    ><i class="far fa-trash-alt me-2"></i
                                    >Delete</a
                                  >
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </a-table>
                </div>
                <div class="d-flex justify-content-end">
                  <a-pagination
                    class="mt-4"
                    :current="currentPage"
                    :total="total"
                    :page-size="perPage"
                    :show-size-changer="false"
                    :show-quick-jumper="false"
                    @change="handlePageChange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>

  <!-- Delete Customer Modal -->
  <div class="modal custom-fade fade" id="delete_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>Delete Customer</h3>
            <p v-if="selectedItem">
              Are you sure want to delete {{ selectedItem.name }}?
            </p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row d-flex flex-column align-items-center">
              <div class="col-6 mb-2">
                <button
                  @click="deleteCustomer"
                  class="w-100 btn btn-primary"
                  :disabled="isDeleting"
                >
                  <span
                    v-if="isDeleting"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isDeleting">Delete</span>
                  <span v-if="isDeleting">Deleting...</span>
                </button>
              </div>
              <div class="col-6">
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete Customer Modal -->
</template>

<script setup>
import { computed, ref, onMounted, watch } from "vue";
import { formatted } from "@/assets/composables/date";
import { useCurrency } from "@/assets/composables/currency";
import { useStore } from "vuex";
import { Modal } from "bootstrap";

const store = useStore();
const isFetching = ref(false);
const currentDate = ref(new Date());
const startdate = ref(currentDate.value);
const currentPage = ref(1);
const perPage = ref(50);
const selectedItem = ref(null);
const modalInstance = ref(null);
const isDeleting = ref(false);

const searchForm = ref({
  search: "",
});

const resetSearchForm = () => {
  searchForm.value = {
    search: "",
  };
};

const handlePageChange = (page) => {
  currentPage.value = page;
};

watch(currentPage, (newValue) => {
  currentPage.value = newValue;
  getCustomers();
});

watch(
  () => searchForm.value,
  (newValue) => {
    let data = {
      current_page: currentPage.value,
      per_page: perPage.value,
      query: newValue.search,
    };
    store.dispatch("customer/getCustomers", data);
  },
  { deep: true }
);

const columns = [
  {
    title: "#",
    key: "index",
    sorter: true,
  },
  {
    title: "Name",
    key: "name",
    sorter: true,
  },
  {
    title: "Email",
    key: "email",
    sorter: true,
  },
  {
    title: "Phone",
    key: "phone",
    sorter: true,
  },
  {
    title: "Amount due",
    key: "amount_due",
    sorter: true,
  },
  {
    title: "Date Added",
    key: "created_at",
    sorter: true,
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

const openModal = (customer) => {
  modalInstance.value.show();
  selectedItem.value = customer;
};
const closeModal = () => {
  modalInstance.value.hide();
};

const customers = computed(() => {
  return store.getters["customer/customers"];
});
const total = computed(() => {
  return store.getters["customer/total"];
});

const getCustomers = () => {
  isFetching.value = true;
  let data = {
    current_page: currentPage.value,
    per_page: perPage.value,
    query: "",
  };
  store
    .dispatch("customer/getCustomers", data)
    .then(() => {
      isFetching.value = false;
    })
    .catch(() => {
      isFetching.value = false;
    });
};
const deleteCustomer = () => {
  isDeleting.value = true;
  store
    .dispatch("customer/deleteCustomer", selectedItem.value.id)
    .then(() => {
      isDeleting.value = false;
      closeModal();
    })
    .catch(() => {
      isDeleting.value = false;
      closeModal();
    });
};

onMounted(() => {
  getCustomers();
  if (document.querySelectorAll(".popup-toggle").length > 0) {
    document.querySelectorAll(".popup-toggle").forEach(function (el) {
      el.addEventListener("click", function () {
        document.querySelector(".toggle-sidebar").classList.add("open-filter");
      });
    });

    document.querySelectorAll(".sidebar-closes").forEach(function (el) {
      el.addEventListener("click", function () {
        document
          .querySelector(".toggle-sidebar")
          .classList.remove("open-filter");
      });
    });
  }

  // Initiate modal
  modalInstance.value = new Modal(document.getElementById("delete_modal"), {
    backdrop: "static",
    keyboard: false,
  });
});
</script>
